export * as appliedResearch from './applied-research'
export * as basicResearch from './basic-research'
export * as clinicalResearch from './clinical-research'
export * as clinicalTrials from './clinical-trials'
export * as demonstrationAndServices from './demonstration-and-service'
export * as equipment from './equipment'
export * as fellowship from './fellowship'
export * as institutionalSupport from './institutional-support'
export * as instructionalActivities from './instructional-activities'
export * as operations from './operations'
export * as program from './program'
export * as publicService from './public-service'
export * as salariesAndWages from './salaries-and-wages'
export * as trainingActivities from './training-activities'
